import axios from "axios";
export default {
    getMenus() {
        return axios.get(`/menus`);
    },
    postMenu(obj) {
        return axios.post(`/menus`, obj);
    },
    putMenu(id, obj) {
        return axios.put(`/menus/${id}`, obj);
    },
    deleteMenu(id) {
        return axios.delete(`/menus/${id}`);
    },
    postMenuMedia(id,obj) {
        return axios.post(`/menus/${id}/media`,
            obj,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
    },
};
